import queryString from 'query-string'
import equals from 'shallow-equals'
import {history} from './history'
import {get, omit} from './object'

// pushParam will merge supplied params with current url params and push them to url
export const pushParam = (param, trackParams = [], exposeParams = []) => {
  const currentParams = paramsFromLocation(location)
  const params = {...currentParams, ...param}
  const omitParams = Object.keys(params).filter(key => params[key] === false || typeof params[key] === 'undefined')
  const sanitizedParams = omit(omitParams, params)
  pushQuery(sanitizedParams, trackParams, exposeParams)
}

// pushQuery will push a new query string from query object supplied
export const pushQuery = (query, trackParams = [], exposeParams = []) => {
  const currentParams = filteredParamsFromLocation(location, exposeParams)
  if (equals(currentParams, query)) return
  const push = Object.keys(query).some(key =>
    trackParams.some(param => param === key && String(currentParams[key]) !== String(query[key])))
  const search = paramsToString(query)
  if (push) {
    history.push({search, breakLoop: true})
  } else {
    history.replace({search, breakLoop: true})
  }
}

export const filteredParamsFromLocation = (location, exposeParams = []) =>
  filterParams(paramsFromLocation(location), exposeParams)

export const paramsFromLocation = location => queryString.parse(location && location.search)

export const filterParams = (params, exposeParams = []) => {
  const filderedParams = exposeParams.reduce(
    (accepted, param) => ({...accepted, [param]: get(param, params)}),
    {},
  )
  Object.keys(filderedParams).forEach(key => filderedParams[key] === undefined && delete filderedParams[key])
  return filderedParams
}

export const paramsToString = (params) => {
  /**
   * This kind of content specific function does not belong here.
   * @todo - Allow search params to be ordered.
   */
  
  // step should be always first in QueryParam because of GTM
  if (params.step === undefined) {
    return queryString.stringify(params)
  }
  const step = params.step
  delete params.step
  let newParams = queryString.stringify(params)
  newParams = `step=${step}&${newParams}`
  return newParams
}



// WEBPACK FOOTER //
// ./src/utils/query.js